import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseField from "./_imports/forms-base-field.vue";
import FormsDisclaimerField from "./forms-disclaimer-field.vue";

export default {
	name: 'forms-disclaimers',
	template: getVueTemplate('forms-disclaimers'),
	mixins: [
		FormsBaseField
	],
	components: {
		FormsDisclaimerField
	},
	props: {
		disclaimers: Array
	},
	data() {
		return {
			validDisclaimer: null
		}
	},
	watch: {
		formState() {
			if (this.formState.formCountry) {
				const validDisclaimers = this.getDisclaimersOfCurrentFormCountry();

				if (validDisclaimers) {
					const validDisclaimersWithCountries = validDisclaimers.filter(disclaimer => disclaimer.countries.length);

					let validDisclaimer = validDisclaimers[0];
	
					if (validDisclaimersWithCountries.length) {
						validDisclaimer = validDisclaimersWithCountries[0];
					}

					this.validDisclaimer = validDisclaimer;
				}
			}
		}
	},
	methods: {
		getDisclaimersOfCurrentFormCountry() {
			return this.disclaimers.filter(disclaimer => disclaimer.countries.some(country => country.name === this.formState.formCountry) || !disclaimer.countries.length);
		},
		onCreated() {
			this.ignore = true;
			this.setDisclaimersIds();
		},
		setDisclaimersIds() {
			this.disclaimers.forEach((disclaimer, index) => disclaimer.disclaimerIndex = index);
		}
	}
};